import request from '@/utils/request'

// 各子系统单独配置

/**
 * 获取配置项列表数据
 */
export const getConfigSettingLists = (data) => {
    return request({
        url: '/config/setting/lists',
        params: data
    })
}
/**
 * 获取配置项列表数据
 */
export const getConfigSettingOptionLists = (data) => {
    return request({
        url: '/config/setting/option/lists',
        params: data
    })
}

// 批量设置值
export const batchConfigSetting = (data) => {
    return request({
        url: '/config/setting/manage',
        method: 'PATCH',
        data: {
            method: 'batch_setting',
            data
        }
    })
}
